import React, { Component } from "react";
import { Container, Row, Col, Card, Carousel, Image, Nav, Tab, Form, Button } from 'react-bootstrap'
import { Link } from "react-router-dom"

import { withRouter } from "react-router-dom";
import { graphql } from "react-apollo";
import gql from "graphql-tag";
import * as Cookies from "es-cookie";
import client from "../../apolloClient";

import "../../_login.scss";

const LOGIN_USER = gql`
  mutation($username: String!, $password: String!) {
    login1(username: $username, password: $password) {
      token
      refreshToken
      user {
        username
        userlevel
        email
        mobile
        valid
        name
        institution_id
        institute_name
        module_access
        subject_ids
        branch_id
        id
      }
    }
  }
`;


class CollegeLogin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentStep: 1,
      username: "",
      password: "",
      submitError: "",
      formErrors: {
        username: "",
        password: ""
      },
      usernameValid: false,
      passwordValid: false,
      formValid: false,
      loader: 0
    };
  }
  handleFormSubmit = e => {
    e.preventDefault();
    this.setState({
      loader: 1
    });
    console.log("Form submitted");
    console.log(this.state);

    if (this.state.formValid) {
      console.log("college login", this.state.username, this.state.password);
      this.login1(this.state.username, this.state.password).catch(error => {
        console.log("catch if error");
        console.log(error);
        this.setState({
          submitError: error.graphQLErrors.map(x => x.message), loader: 0
        });
        console.error(
          "ERR =>",
          error.graphQLErrors.map(x => x.message)
        );
      });
    } else {
      this.setState({ submitError: "Please fill all the values to proceed", loader: 0 });
    }
  };
  login1 = async (username, password) => {
    const result = await this.props.login1({
      variables: {
        username,
        password
      },
      update: (store, { data }) => {
        Cookies.set("token", data.login1.token);
        Cookies.set("refreshtoken", data.login1.refreshToken);
        Cookies.set("username", data.login1.user.username);
        Cookies.set("name", data.login1.user.name);
        Cookies.set("email", data.login1.user.email);
        Cookies.set("id", data.login1.user.id);
        Cookies.set("institutionid", data.login1.user.institution_id);
        Cookies.set("role", "institution");
        Cookies.set("institutename", data.login1.user.institute_name);

        // Cookies.set(
        //     "fullname",
        //     data.login.user.firstname + " " + data.login.user.lastname
        // );
        Cookies.set("userlevel", data.login1.user.userlevel);
        // Logged-in faculty's subjects — used to scope Student Doubts to the
        // subjects they teach (empty = admin/non-teacher → sees all).
        Cookies.set("subject_ids", String(data.login1.user.subject_ids || ""));
        localStorage.setItem("moduleRestrictions", JSON.stringify(data.login1.user.module_access))
      }
    });

    // After mutation completes, set branch_id from the backend natively
    const userData = result.data.login1.user;
    Cookies.set("branch_id", String(userData.branch_id || ""));

    this.setState({ loader: 0 });
    if (result.data.login1) {
      this.props.history.push("/");
    }
  };
  handleInputChange = e => {
    const name = e.target.name;
    const value = e.target.value;
    this.setState({ [name]: value }, () => {
      this.validateField(name, value);
    });
  };
  validateField(fieldName, value) {
    let fieldValidationErrors = this.state.formErrors;
    let usernameValid = this.state.usernameValid;
    let passwordValid = this.state.passwordValid;

    switch (fieldName) {
      case "username":
        var pattern = new RegExp(
          /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
        );

        if (value.length < 4) {
          usernameValid = false;
          fieldValidationErrors.username =
            "Username cannot be less than 5 chars";
        }
        // else if (!pattern.test(value)) {
        //   usernameValid = false;
        //   fieldValidationErrors.username = "Invalid Username";
        // } 
        else {
          usernameValid = true;
          fieldValidationErrors.username = "";
        }

        break;
      case "password":
        if (value.length == "") {
          passwordValid = false;
          fieldValidationErrors.password = "Password cannot be Empty";
        } else {
          passwordValid = true;
          fieldValidationErrors.password = "";
        }

        break;

      default:
        break;
    }
    this.setState(
      {
        formErrors: fieldValidationErrors,
        usernameValid: usernameValid,
        passwordValid: passwordValid
      },
      this.validateForm
    );
  }

  validateForm() {
    this.setState({
      formValid: this.state.passwordValid || this.state.usernameValid
    });
    if (this.state.formValid) {
      this.setState({ submitError: "" }, () => { });
    }
  }

  render() {
    if (
      Cookies.get("token") != undefined &&
      Cookies.get("institutionid") != undefined
    ) {
      this.props.history.push("/questions/manage-question-paper");
    }


    return (
      <div className="login_new_design">
        <header className="header-one mb-3">
          <div className="container">
            <div className="row">
              <div className="col-sm-12">
                <a href="#"><img className="img-fluid college_logo  p-2 mt-4 center-res-img" src={require('../../images/dinesh_publications.gif')} alt="Logo" /></a>
              </div>
            </div>
          </div>
        </header>
        <section className="banner_blue">
          <div className="container">
            <div className="row">
              <div className="col-sm-8">
                <Card className="text-white card_transparent">
                  <Card.Img src={require('../../images/blub.png')} className="width_blub_img image-color-change center-img" alt="Card image" />
                  <Card.ImgOverlay>
                    <Card.Title className="f-75 mt-5 res_hide">Welcome,<br />Launch your <span class="color_yellow">Institute</span> <br />Live Exams with <span class="color_yellow">Dinesh Publications</span></Card.Title>
                    <Card.Title className="f-60 mt-4 res_show">Welcome, <span className="font_align">Launch your Live <span class="color_yellow">Institute</span> Exams with <span class="color_yellow">Dinesh Publications</span></span></Card.Title>

                    {/* <Card.Title className="f-75 mt-5 res_hide main_text_college">Welcome, <br /> Launch your <span class="color_yellow">Institute <br /> </span> Live Exams with <span class="color_yellow fw-bold">  DINESH PUBLICATION</span></Card.Title>
                    <Card.Title className="f-60 mt-4 res_show">Welcome, <span className="font_align">Launch your Live <span class="color_yellow">Institute</span> Exams with <span class="color_yellow">DINESH PUBLICATION</span></span></Card.Title> */}
                  </Card.ImgOverlay>
                </Card>
              </div>
              <div className="col-sm-4">
                <div className="row">
                  <div className="col-sm-12">
                    <div className="white_block">

                      <Form>
                        {this.state.currentStep == 5 ? (
                          <Form.Text className="form-text text-danger">
                            You are successfully loggedIn
                          </Form.Text>
                        ) : (
                          <Form.Text className="form-text text-danger">
                            {this.state.submitError}
                          </Form.Text>
                        )}
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                          <Form.Label className="font-weight-bold f-16 color_yash"> <i className="far fa-envelope mr-2" /> UserName / Email</Form.Label>
                          <Form.Control type="text" className="input_custom" placeholder="Enter Name" onChange={this.handleInputChange} name="username" />
                          <Form.Text className="form-text text-danger">
                            {this.state.formErrors.username}
                          </Form.Text>
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="formBasicPassword">
                          <Form.Label className="font-weight-bold f-16 color_yash"> <i className="fas fa-lock mr-2" /> Password</Form.Label>
                          <Form.Control type="password" className="input_custom" placeholder="Password" onChange={this.handleInputChange} name="password" />
                          <Form.Text className="form-text text-danger">
                            {this.state.formErrors.password}
                          </Form.Text>
                        </Form.Group>

                        {this.state.loader == 1 ? (
                          <Button className="btn-block btn-light-blue" type="submit" block disabled style={{ width: "" }}>
                            <span className="spinner-border spinner-border-sm"></span>
                            logging..
                          </Button>
                        ) : (
                          <Button onClick={this.handleFormSubmit} className="btn-block btn-light-blue" type="submit" block>
                            Login <i class="fas fa-long-arrow-alt-right ml-3"></i>
                          </Button>
                        )}

                        {/* <h6 className="text-center mt-4 color_yash">Don't have an account? <a href="https://rizee.in/college/?src=CEmail" className="color_black font-weight-bold">Register</a></h6> */}
                      </Form>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </section>
        <section className="bg_white mt-res-10">
          <div className="container">
            <div className="row">
              <div className="col-sm-6 mt-5 mb-4 res_hide">
                <img className="width_blub_glow_img center-img" src={require('../../images/blub_glow.png')} alt="blub_glow" />
              </div>
              <div className="col-sm-6 mt-5 mb-4">
                <h2 className="text-center-res">Monitor your Students in Realtime </h2>
                <ul className="list-inline custom_list_css mt-4">
                  <li>
                    All Services that students see are under your <b>Institute Name</b>
                  </li>
                  <li>
                    Create your own <b>Questions & Content library</b>
                  </li>
                  <li>
                    <b>Auto - Generated</b> Question Papers in latest patterns
                  </li>
                  <li>
                    <b>Smart features</b> to save your time & efforts
                  </li>
                  <li>
                    Explore Student & Teacher <b>Activity reports</b>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>
        <section className="mt-res-5 mb-res-5 bg_light_green">
          <div className="container res_hide">
            <div className="row justify-content-center">
              <div className="col-sm-9">
                <div className="white_block_new">
                  <h2 className="text-center mt-3">Everything you Need is in DINESH PUBLICATION</h2>
                  <div className="row">
                    <div className="col-sm-6">
                      <ul className="list-inline custom_list_icons mt-4">
                        <li>
                          <img className="" src={require('../../images/icon1.png')} alt="icon" /> <span>Make Your Online Presence Felt all over India</span>
                        </li>
                        <li>
                          <img className="" src={require('../../images/icon2.png')} alt="icon" /> <span>One Solution For Online or Offline Exams</span>
                        </li>
                        <li>
                          <img className="" src={require('../../images/icon3.png')} alt="icon" /> <span>Manage Student and Faculty Data</span>
                        </li>
                        <li>
                          <img className="" src={require('../../images/icon4.png')} alt="icon" /> <span>Manage your organisation From One Platform</span>
                        </li>

                      </ul>
                    </div>
                    <div className="col-sm-6">
                      <ul className="list-inline custom_list_icons mt-4">
                        <li>
                          <img className="" src={require('../../images/icon5.png')} alt="icon" /> <span>Notify Students For Each Activity</span>
                        </li>
                        <li>
                          <img className="" src={require('../../images/icon6.png')} alt="icon" /> <span>Improve Your Admission Process with Us</span>
                        </li>
                        <li>
                          <img className="" src={require('../../images/icon7.png')} alt="icon" /> <span>Make Exam Creation Easy For You</span>
                        </li>
                        <li>
                          <img className="" src={require('../../images/icon8.png')} alt="icon" /> <span>Monitor Each Students Exam Report</span>
                        </li>

                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="res_show container">
            <div className="row">
              <div className="col-sm-12">
                <h2 className="text-center mt-4">Everything you Need is in DINESH PUBLICATION</h2>
                <ul className="list-inline custom_list_icons mt-4">
                  <li>
                    <img className="" src={require('../../images/icon1.png')} alt="icon" /> <span>Make Your Online Presence Felt all over India</span>
                  </li>
                  <li>
                    <img className="" src={require('../../images/icon2.png')} alt="icon" /> <span>One Solution For Online or Offline Exams</span>
                  </li>
                  <li>
                    <img className="" src={require('../../images/icon3.png')} alt="icon" /> <span>Manage Student and Faculty Data</span>
                  </li>
                  <li>
                    <img className="" src={require('../../images/icon4.png')} alt="icon" /> <span>Manage your organisation From One Platform</span>
                  </li>
                  <li>
                    <img className="" src={require('../../images/icon5.png')} alt="icon" /> <span>Notify Students For Each Activity</span>
                  </li>
                  <li>
                    <img className="" src={require('../../images/icon6.png')} alt="icon" /> <span>Improve Your Admission Process with Us</span>
                  </li>
                  <li>
                    <img className="" src={require('../../images/icon7.png')} alt="icon" /> <span>Make Exam Creation Easy For You</span>
                  </li>
                  <li>
                    <img className="" src={require('../../images/icon8.png')} alt="icon" /> <span>Monitor Each Students Exam Report</span>
                  </li>

                </ul>
              </div>
            </div>
          </div>
        </section>
        <section className="bg_blue_light">
          <div className="container">
            <div className="row">
              <div className="col-sm-6 mt-5 mb-4">
                <img className="width_blub_glow_img center-img" src={require('../../images/contact_college.png')} alt="contact_college" />
              </div>
              <div className="col-sm-6 mt-6 mb-4">
                <h2 className="color_white text-center">Contact Us</h2>
                <h5 className="text-center mt-4">
                  <span className="white_border">
                    <a href="https://wa.me/919154110191" target="_blank" rel="noopener noreferrer" className="text-decoration-none">
                      <i className="fab fa-whatsapp mx-2"></i>
                      <i className="fas fa-phone-alt mx-2"></i>
                      +91 91541-10191
                    </a>
                  </span>
                </h5>
              </div>
            </div>
          </div>
        </section>

        <footer >
          <Row className="align-items-center">
            <Col sm={6}>
              <p>&copy; 2024 Rizee Web App. All rights reserved</p>
            </Col>
            <Col sm={6}>
              <p className="product_brand"> Powered by  <span className="product_brand_sub">Rizee</span></p>
            </Col>
          </Row>
        </footer>
      </div>
    );
  }
}
export default withRouter(
  graphql(LOGIN_USER, {
    name: "login1"
  })(CollegeLogin)
);
